// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Antd = require("antd");
var Curry = require("rescript/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var React = require("react");
var Head = require("next/head").default;
var Antd_Input = require("@smartcuts/rescript-antd/src/components/Antd_Input.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var Router = require("next/router");
var Segment$SmartcutsMacros = require("../../packages/bs-analytics/src/Segment.bs.js");
var ReactUtils$SmartcutsMacros = require("../../packages/bs-utils/src/ReactUtils.bs.js");
var LayoutPublic$SmartcutsMacros = require("../components/LayoutPublic.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../packages/bs-utils/src/PromiseUtils.bs.js");

function requestForgotPassword(email) {
  Segment$SmartcutsMacros.trackUserForgotPassword(undefined);
  return fetch("/api/forgot_password", Fetch.RequestInit.make(/* Post */2, {
                    "Content-Type": "application/json"
                  }, Caml_option.some(JSON.stringify(Json_encode.object_({
                                hd: [
                                  "email",
                                  email
                                ],
                                tl: /* [] */0
                              }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
}

function PageForgotPassword(Props) {
  var router = Router.useRouter();
  var match = React.useState(function () {
        return {
                email: "",
                isRequestingForgotPassword: false
              };
      });
  var setState = match[1];
  var match$1 = match[0];
  var email = match$1.email;
  return React.createElement(LayoutPublic$SmartcutsMacros.make, {
              onClickCallToAction: (function (param) {
                  router.push("/", undefined, undefined);
                  
                }),
              children: null
            }, React.createElement(Head, {
                  children: React.createElement("title", undefined, ReactUtils$SmartcutsMacros.s("Forgot Password"))
                }), React.createElement("section", {
                  className: Curry._1(Css.style, {
                        hd: Css.maxWidth({
                              NAME: "px",
                              VAL: 720
                            }),
                        tl: {
                          hd: Css.selector("& > *", {
                                hd: Css.margin2({
                                      NAME: "px",
                                      VAL: 30
                                    }, "zero"),
                                tl: /* [] */0
                              }),
                          tl: {
                            hd: Css.selector("h2", {
                                  hd: Css.textAlign("center"),
                                  tl: /* [] */0
                                }),
                            tl: {
                              hd: Css.selector("form", {
                                    hd: Css.display("flex"),
                                    tl: {
                                      hd: Css.flexDirection("column"),
                                      tl: {
                                        hd: Css.padding2("zero", {
                                              NAME: "px",
                                              VAL: 30
                                            }),
                                        tl: {
                                          hd: Css.selector("& > *", {
                                                hd: Css.margin2({
                                                      NAME: "px",
                                                      VAL: 10
                                                    }, "zero"),
                                                tl: /* [] */0
                                              }),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement("h2", undefined, ReactUtils$SmartcutsMacros.s("Forgot Password?")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("To reset your password, please enter the email address you used to register with Smartcuts. "), ReactUtils$SmartcutsMacros.s("We will send you an email with instructions to reset your password.")), React.createElement(Antd.Form, {
                      children: null
                    }, React.createElement(Antd_Input.make, {
                          placeholder: "yourname@example.com",
                          onChange: (function ($$event) {
                              var target = $$event.target;
                              return Curry._1(setState, (function (state) {
                                            return {
                                                    email: target.value,
                                                    isRequestingForgotPassword: state.isRequestingForgotPassword
                                                  };
                                          }));
                            })
                        }), React.createElement(Antd.Button, {
                          disabled: match$1.isRequestingForgotPassword || email === "",
                          type: "primary",
                          onClick: (function (param) {
                              Curry._1(setState, (function (state) {
                                      return {
                                              email: state.email,
                                              isRequestingForgotPassword: true
                                            };
                                    }));
                              PromiseUtils$SmartcutsMacros.map(requestForgotPassword(email), (function (param) {
                                      Antd.message.success(React.createElement(React.Fragment, undefined, ReactUtils$SmartcutsMacros.s("If you have registered with "), React.createElement("strong", undefined, ReactUtils$SmartcutsMacros.s(email)), ReactUtils$SmartcutsMacros.s(", you will receive an email. Please check your inbox.")), 3, undefined);
                                      return Curry._1(setState, (function (state) {
                                                    return {
                                                            email: state.email,
                                                            isRequestingForgotPassword: false
                                                          };
                                                  }));
                                    }));
                              
                            }),
                          children: ReactUtils$SmartcutsMacros.s("Send me an email")
                        }))));
}

var make = PageForgotPassword;

exports.requestForgotPassword = requestForgotPassword;
exports.make = make;
/* Css Not a pure module */
